/**
 * Fiskil client-side state.
 *
 * BACKEND DELEGATION: end_user_id and access_token are stored on the backend.
 * No client-side Fiskil state is persisted; clearFiskilStore is a no-op for API compatibility.
 */

export function clearFiskilStore(): void {
  // No client-side Fiskil state to clear; backend owns end_user_id and token.
}
